import React, { useEffect, useMemo, useState } from 'react';
import { Checkbox } from '@mui/material';

export interface ICheckboxGroupItem {
  label: string;
  value: string;
}

interface ICheckboxGroupItemExtended extends ICheckboxGroupItem {
  id: string;
}

interface IProps {
  options: ICheckboxGroupItem[];
  onChange: (options: ICheckboxGroupItemExtended[]) => void;
}

const CheckboxGroup: React.FC<IProps> = ({ options, onChange }) => {
  const [selectedOptions, setSelectedOptions] = useState<ICheckboxGroupItemExtended[]>([]);

  const handleSelection = (optionObject: ICheckboxGroupItemExtended) => () => {
    const isSelected = selectedOptions.some(
      selectedOption => selectedOption.id === optionObject.id,
    );

    let newSelectedOptions;

    if (!isSelected) {
      // adding new item to selected list
      newSelectedOptions = selectedOptions.length
        ? [...selectedOptions, optionObject]
        : [optionObject];
    } else {
      // removing item from selected list
      newSelectedOptions = selectedOptions.filter(i => i.id !== optionObject.id);
    }

    setSelectedOptions(newSelectedOptions);
  };

  const extendedOptions = useMemo(
    (): ICheckboxGroupItemExtended[] =>
      options.map(option => ({
        ...option,
        id: `${option.value}-${Math.random().toString(10).slice(2)}`,
      })),
    [],
  );

  useEffect(() => {
    onChange(selectedOptions);
  }, [selectedOptions]);

  return (
    <>
      {extendedOptions.map(option => (
        <div key={option.id}>
          <Checkbox
            style={{ marginRight: 8 }}
            checked={selectedOptions.some(selectedOption => selectedOption.id === option.id)}
            onClick={handleSelection(option)}
          />
          {option.label}
        </div>
      ))}
    </>
  );
};

export default CheckboxGroup;
